// Admin API client for the GeneratedPdf jobs dashboard. Thin axios
// wrappers over /v1/admin/pdf-jobs endpoints registered by
// apps/mdl-backend/src/routes/pdf-admin.routes.ts.

import axios from '@/api/axios.config'
import type { PdfStatusKey } from '@messenger/types'

export type PdfJobRow = {
  id: string
  orderId: string | null
  orderPageSetId: string | null
  pdfType: string
  progress: number
  url: string | null
  productId: string | null
  createdAt: string
  createdBy: string | null
  updatedAt: string
  updatedBy: string | null
  status: PdfStatusKey
  screenshotUrls: string[]
  screenshotStatus: string | null
  galleryToken: string | null
  galleryUrl: string | null
  jobPayload: Record<string, unknown> | null
  errorMessage: string | null
  debugLogs: Record<string, unknown> | null
  downloadUrl: string | null
  viewUrl: string | null
  jobKind: 'final' | 'digital-proof'
  productName: string | null
  funeralHomeName: string | null
  funeralHomeId: string | null
  caseId: string | null
  caseName: string | null
}

export type PdfJobsListResponse = {
  items: PdfJobRow[]
  total: number
  page: number
}

export type ListPdfJobsQuery = {
  page?: number
  pageSize?: number
  status?: PdfStatusKey
  pdfType?: string
  orderId?: string
  productId?: string
  createdById?: string
  fromDate?: string
  toDate?: string
  onlyFinals?: boolean
}

export const listPdfJobs = async (query?: ListPdfJobsQuery) =>
  await axios.get<PdfJobsListResponse>('/admin/pdf-jobs', { params: query })

export const getPdfJob = async (id: string) =>
  await axios.get<PdfJobRow>(`/admin/pdf-jobs/${id}`)

export const resubmitPdfJob = async (id: string) =>
  await axios.post<PdfJobRow>(`/admin/pdf-jobs/${id}/resubmit`)
